import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { HomeComponent } from './core/home/home.component';
import { LoginComponent } from './login/login.component';
import { AuthGuard } from './services/auth-guard.service';
import { AuthGuardMenu } from './services/auth-guard-menu.service';

const right = 'right';
const center = 'center';

const appRoutes: Routes = [
  { path: '', redirectTo: '/home', pathMatch: 'full' },
  { path: 'login', component: LoginComponent },
  {
    path: 'home', component: HomeComponent,
    canActivate: [AuthGuard],
    canActivateChild: [AuthGuard]
  },
  {
    path: 'newcar',
    loadChildren: './newcar/newcar.module#NewcarModule'
  },
  {
    path: 'usedcar',
    loadChildren: './usedcar/usedcar.module#UsedcarModule'
  },
  {
    path: 'sales',
    loadChildren: './sales/sales.module#SalesModule'
  },
  {
    path: 'planmain',
    loadChildren: './plan/plan.module#PlanModule',
    canActivate: [AuthGuard, AuthGuardMenu],
    canActivateChild: [AuthGuard]
  },
  {
    path: 'business-manage',
    loadChildren:
      './business-manage/business-manage.module#BusinessManageModule'
  },
  {
    path: 'fukusha',
    loadChildren: './fukusha/fukusha.module#FukushaModule'
  },
  {
    path: 'osusume',
    loadChildren: './osusume/osusume.module#OsusumeModule',
    canActivate: [AuthGuard],
    canActivateChild: [AuthGuard]
  }
];
// {
//   path: 'plan',
//   component: PlanComponent,
//   canActivate: [AuthGuard],
//   children: [
//     // dealer-option
//     {
//       path: 'dealer-option',
//       children: [
//         { path: '', component: PaymentDealerOptionComponent, outlet: center },
//         { path: '', component: PlanDealerOptionComponent, outlet: right }
//       ]
//     },

//     // delivery
//     {
//       path: 'delivery',
//       children: [
//         { path: '', component: PlanDeliveryComponent, outlet: right }
//       ]
//     },

//     // customer
//     {
//       path: 'customer',
//       children: [
//         { path: '', component: PlanCustomerComponent, outlet: right }
//       ]
//     },

//     // insurance
//     {
//       path: 'insurance',
//       children: [
//         { path: '', component: PaymentInsuranceComponent, outlet: center },
//         { path: '', component: PlanInsuranceComponent, outlet: right }
//       ]
//     },

//     // loan
//     {
//       path: 'loan',
//       children: [
//         { path: '', component: PaymentLoanComponent, outlet: center },
//         { path: '', component: PlanLoanComponent, outlet: right }
//       ]
//     },

//     // recycling
//     {
//       path: 'recycling',
//       children: [
//         { path: '', component: PaymentRecyclingComponent, outlet: center },
//         { path: '', component: PlanRecyclingComponent, outlet: right }
//       ]
//     },

//     // remark
//     {
//       path: 'remark',
//       children: [{ path: '', component: PlanRemarkComponent, outlet: right }]
//     },

//     // selling-notax
//     {
//       path: 'selling-notax',
//       children: [
//         { path: '', component: PaymentSellingNotaxComponent, outlet: center },
//         { path: '', component: PlanSellingNotaxComponent, outlet: right }
//       ]
//     },

//     // store-option
//     {
//       path: 'store-option',
//       children: [
//         { path: '', component: PaymentStoreOptionComponent, outlet: center },
//         { path: '', component: PlanStoreOptionComponent, outlet: right }
//       ]
//     },

//     // trade-in
//     {
//       path: 'trade-in',
//       children: [
//         { path: '', component: PaymentTradeInComponent, outlet: center },
//         { path: '', component: PlanTradeInComponent, outlet: right }
//       ]
//     },

//     // usedcar
//     {
//       path: 'usedcar',
//       children: [
//         { path: '', component: PlanUsedcarComponent, outlet: center }
//       ]
//     },

//     // select
//     {
//       path: 'select',
//       children: [{ path: '', component: PlanSelectComponent, outlet: right }]
//     }
//   ]
// },

//  { path: 'promotion-material', component: PromotionMaterialComponent, canActivate: [AuthGuard] },

@NgModule({
  imports: [
    RouterModule.forRoot(appRoutes, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }



// WEBPACK FOOTER //
// ./src/app/app.routing.ts